import globalApi from '../../api'

export const getChallengeParticipationListApi = ({ filter }) =>
  globalApi.post('/Challenge/GetChallengeParticipationList', { ...filter, isSecured: true })

export const acceptChallengeParticipationApi = (challengeParticipationId) => 
  globalApi.post('/Challenge/AcceptChallengeParticipation', {
    challengeParticipationId,
    isSecured: true,
})

export const cancelChallengeParticipationApi = (challengeParticipationId) => 
  globalApi.post('/Challenge/CancelChallengeParticipation', {
    challengeParticipationId,
    isSecured: true,
})